<template>
  <div>
    <span>
      <b-button v-on:click="detailOne()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetailOne"
          width="20"
          height="20"
          :color="params.iconColorOne"
					 v-b-tooltip.hover.bottom="$t(params.tooltipOne)"
        /> 
      </b-button>
    </span>
		<span>
      <b-button v-on:click="detailTwo()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetailTwo"
          width="20"
          height="20"
          :color="params.iconColorTwo"
					 v-b-tooltip.hover.bottom="$t(params.tooltipTwo)"
        />
      </b-button>
    </span>
		<span>
      <b-button v-on:click="detailTree()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetailTree"
          width="20"
          height="20"
          :color="params.iconColorTree"
					 v-b-tooltip.hover.bottom="$t(params.tooltipTree)"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: [
    "detailMethodsOne",
    "tooltipOne",

    "iconDetailOne",
    "iconColorOne",
    "detailMethodsTwo",
    "tooltipTwo",

    "iconDetailTwo",
    "iconColorTwo",
    "detailMethodsTree",
    "tooltipTree",

    "iconDetailTree",
    "iconColorTree",
  ],
  components: { Icon },
  methods: {
    detailOne() {
      this.$root.$emit(this.params.detailMethodsOne, this.params.data);
    },
		detailTwo() {
      this.$root.$emit(this.params.detailMethodsTwo, this.params.data);
    },
		detailTree() {
      this.$root.$emit(this.params.detailMethodsTree, this.params.data);
    },
  },
};
</script>
